import { SxStyle } from '../../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGrid: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center'
};

const contentContainerGridItem1Typography: SxStyle = {
    fontWeight: 700
};

const contentContainerGridItem2Box: SxStyle = {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center'
};

const contentContainerGridItem3TabPanel: SxStyle = {
    padding: 0
};

// actions datagrid
const dataGridMenuMenuItemListItemIcon: SxStyle = {
    minWidth: '30px'
};

// columns datagrid
const dataGrid1Box1: SxStyle = {
    minWidth: '50px',
    width: '50px', 
    height: '30px', 
    borderRadius: '5px', 
    marginRight: '14px', 
    marginLeft: '14px'
};

const dataGrid1Box2: SxStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const dataGrid1Box2AvatarGroup: SxStyle = {
    marginRight: '16px'
};

const dataGrid1Box2AvatarGroupAvatar: SxStyle = {
    width: 32,
    height: 32
};

const dataGrid2Box1: SxStyle = {
    minWidth: '50px',
    width: '50px', 
    height: '30px', 
    borderRadius: '5px', 
    marginRight: '14px', 
    marginLeft: '14px'
};

const dataGrid2Box2Chip1: SxStyle = {
    width: 160,
    color: '#10B23D',
    backgroundColor: '#E3F5E8'
};

const dataGrid2Box2Chip2: SxStyle = {
    width: 160,
    color: '#CD1818',
    backgroundColor: '#F5E5E3'
};

const dataGrid2Box2Button: SxStyle = {
    marginRight: '8px'
};

export const projectStyle = {
    contentContainer,
    contentContainerGrid,
    contentContainerGridItem1Typography,
    contentContainerGridItem2Box,
    contentContainerGridItem3TabPanel,
    dataGridMenuMenuItemListItemIcon,
    dataGrid1Box1,
    dataGrid1Box2,
    dataGrid1Box2AvatarGroup,
    dataGrid1Box2AvatarGroupAvatar,
    dataGrid2Box1,
    dataGrid2Box2Chip1,
    dataGrid2Box2Chip2,
    dataGrid2Box2Button
};